import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vShow as _vShow, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-primary btn-lg",
  disabled: ""
}
const _hoisted_5 = {
  key: 1,
  class: "container"
}

import { ref, computed, onMounted } from 'vue'

    import ValidationError from '@common/Components/ValidationError.vue'
    import { useCreateOrganizationUnitCommandV1 } from '@Organizations/OrganizationUnits/commands-vue-composables'

    // ---------------- local state ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateOrganizationPage',
  setup(__props) {

    const name = ref('')
    const description = ref('')

    // ---------------- command ----------------

    const {
        invokeCreateOrganizationUnitCommandV1,
        invokingCreateOrganizationUnitCommandV1,
        succeedCreateOrganizationUnitCommandV1,
        validationErrorsCreateOrganizationUnitCommandV1
    } = useCreateOrganizationUnitCommandV1(
        '0',
        name,
        description
    )

    // ---------------- lifecycle ----------------

    onMounted(() =>
    {
        document.title = 'Create an organization'
    })

    // ---------------- derived (template compatibility) ----------------
    const statusInvoking = computed(() => invokingCreateOrganizationUnitCommandV1.value)
    const statusSucceed = computed(() => succeedCreateOrganizationUnitCommandV1.value)
    const validationErrors = computed(() => validationErrorsCreateOrganizationUnitCommandV1.value)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"container\"><div class=\"row\"><div class=\"col-lg-7\"><h1 style=\"font-size:2em;font-weight:300;color:#33475b;margin-top:20px;\">Create an organization</h1></div></div></div><hr style=\"border-color:#bbb;margin:20px 0 30px;\">", 2)),
    (!statusSucceed.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { for: "Name" }, "Name:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
              type: "text",
              class: "form-control",
              placeholder: "Name of organization"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, name.value]
            ]),
            _createVNode(ValidationError, {
              context: "Name",
              errors: validationErrors.value
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { for: "Description" }, "Description:", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
              class: "form-control",
              placeholder: "Description of organization"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, description.value]
            ]),
            _createVNode(ValidationError, {
              context: "Description",
              errors: validationErrors.value
            }, null, 8 /* PROPS */, ["errors"])
          ]),
          _withDirectives(_createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(invokeCreateOrganizationUnitCommandV1) && _unref(invokeCreateOrganizationUnitCommandV1)(...args))),
            type: "button",
            class: "btn btn-primary btn-lg"
          }, "Create", 512 /* NEED_PATCH */), [
            [_vShow, !statusInvoking.value]
          ]),
          _withDirectives(_createElementVNode("button", _hoisted_4, "Creating...", 512 /* NEED_PATCH */), [
            [_vShow, statusInvoking.value]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("h1", null, "Congratulation!", -1 /* CACHED */),
          _createElementVNode("h3", null, "Organization was created. Now you can switch to this organization.", -1 /* CACHED */),
          _createElementVNode("a", {
            class: "btn btn-primary btn-lg",
            href: "/#/admin/organizations/manage",
            role: "button"
          }, "Manage organizations", -1 /* CACHED */)
        ]))]))
  ]))
}
}

})